export default __webpack_public_path__ + "images/28431112953be96fdbf99b8bba9fc2b6.png";